import Loading from '../../../Components/Loading';
import { useAppSelector } from '../../../hooks';
import { useEffect, useState } from 'react';
import { Button, Container, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { Switch } from '@mui/material';
import { Promo } from './PromotionsReport';
import { toTitleCase } from '../../../Utility/toTitleCase';
import './Promotions.css';

type Props = {
    visible: boolean;
    onClose: () => void;
    custID: string | null;
};

const CustomerPromosModal = ({ visible, onClose, custID }: Props) => {
    const baseUrl = `https://customer.hirsch.com/promos/v2/customer`;
    const [allTag, setAllTag] = useState<boolean>(false);
    const token = useAppSelector((state) => state.auth.token);
    const [custPromo, setCustPromo] = useState<Promo[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const activeAll = allTag ? 'All' : 'Active';

    useEffect(() => {
        if (!visible || !custID) return;
        getCustPromo();
    }, [allTag, custID]);

    const getCustPromo = async() => {
        try {
            setLoading(true);
            
            const query = allTag ? '&all=true' : '';
            const response = await fetch(`${baseUrl}?id=${custID}${query}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': btoa(`Bearer ${token}`),
                }
            });

            const json = await response.json();
            
            setCustPromo(json.promos);

            setLoading(false);
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <div>
            <Modal
                isOpen={visible}
                onClosed={onClose}
                fullscreen
                unmountOnClose
            >   
                <ModalHeader 
                    className='bg-primary d-flex justify-content-center'
                    style={{ color: 'white', }}
                >
                    <Button 
                        title='Close'
                        onClick={onClose}
                        className="bg-transparent border-0 fw-bold text-white position-absolute start-0 ms-2"
                    >
                        Close
                    </Button>

                    <span style={{ color: 'white', fontWeight: 'bold', fontSize: 18,}}>Customer Promos</span>
                </ModalHeader>
                <ModalHeader
                    className='d-flex justify-content-center border-0'
                >
                    <div 
                        className='pt-3 bg-white text-center d-block'
                    >
                        {custPromo.length > 0 && (
                            <span className='headerText'>
                                {toTitleCase(custPromo[0].NAME)}
                            </span>
                        )}
                        <div style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                            <span style={{ fontWeight: 'bold', textAlign: 'center' }}>{`${activeAll} Promos`}</span>
                            <Switch 
                                checked={allTag}
                                onChange={() => setAllTag(!allTag)}
                                sx={{
                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                    color: '#f1b434',
                                    },
                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                    backgroundColor: '#f1b434',
                                    },
                                }}
                            />
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    {loading ? (<Loading />)
                    : (
                        <div>
                            <Container className='bg-white'>
                                {custPromo.length > 0 
                                    ?
                                    (
                                        <div>
                                            <Container className='text-center bg-white shadow'>
                                                {custPromo.map((promo: Promo) => (
                                                    <Row 
                                                        className='border py-2'
                                                        key={promo.PROMO}
                                                    >
                                                        <span style={{ fontWeight: 'bold' }}>{promo.PROMO}</span>
                                                        <span>{promo.DESC}</span>
                                                        <div style={{ flexDirection: 'row', paddingTop: 10}}>
                                                            <span style={{ fontWeight: 'bold' }}>Dollars: </span>
                                                            <span>${promo.DOLLARS}</span>
                                                        </div>
                                                        <div style={{ flexDirection: 'row'}}>
                                                            <span style={{ fontWeight: 'bold' }}>Units: </span>
                                                            <span>{promo.UNITS}</span>
                                                        </div>
                                                        <div style={{ flexDirection: 'row'}}>
                                                            <span style={{ fontWeight: 'bold' }}>Start: </span>
                                                            <span>{promo["PROMO_START_DT"]}</span>
                                                        </div>
                                                        <div style={{ flexDirection: 'row'}}>
                                                            <span style={{ fontWeight: 'bold' }}>Ends: </span>
                                                            <span>{promo["PROMO_END_DT"]}</span>
                                                        </div>
                                                    </Row>    
                                                ))}
                                            </Container>
                                        </div>
                                    )
                                    :
                                    (
                                        <div style={{ marginTop: 10 }} className='text-center'>
                                            <span 
                                                className='headerText'
                                            >
                                                Customer {custID} does not have any active promos. Use the toggle to view previous promos.
                                            </span>
                                        </div>
                                    )
                                }
                            </Container>
                        </div>
                    )}
                </ModalBody>
            </Modal>
        </div>
    )
};

// const styles = StyleSheet.create({
//     modalHeader: {
//     },
//     headerText: {
//         fontSize: 16,
//         fontWeight: 'bold',
//         marginVertical: 5,
//         textAlign: 'center',
//         alignSelf: 'center'
//     },
//     itemContainer: {
//         alignItems: 'center',
//         backgroundColor: '#f9f9f9',
//         paddingHorizontal: 16,
//         padding: 5,
//         marginBottom: 8,
//         borderRadius: 5,
//         shadowColor: '#000',
//         shadowOffset: { width: 0, height: 1 },
//         shadowOpacity: 0.2,
//         shadowRadius: 1.41,
//         elevation: 2,
//         width: '100%'
//     },
// })

export default CustomerPromosModal;